import {OpenStreetMapComponent} from '@components/openstreetmap/openstreetmap.component';

export type BidMapLatLngBounds = {
  minLat: number;
  maxLat: number;
  minLng: number;
  maxLng: number;
};

export function getBidMapBounds(osm: OpenStreetMapComponent): BidMapLatLngBounds | null {
  try {
    const m = osm.getMapInstance();
    const b = m?.getBounds?.();
    if (!b) {
      return null;
    }
    return {
      minLat: b.getSouth(),
      maxLat: b.getNorth(),
      minLng: b.getWest(),
      maxLng: b.getEast(),
    };
  } catch {
    return null;
  }
}
